import Vue from "vue";
import { mapGetters } from "vuex";
import { scrollToPaymentMethods, checkCompanyRequiredFields, scrollToCompanyRequiredFields } from "../../../checkout/checkoutUtil";
import { removeCurrencyFromStringAndConverToNumber } from "../../../components/convertUtils";

/**
 * Order summary total Component
 */
const OrderSummaryTotal = Vue.component("order-summary-total", {
    template:/*html*/ `
    <div class="ct-cart--subtotal d-flex align-items-center mb-3 mb-md-4">
        <div :class="['ct-cart--tablet-entrega-zero', resources.isEntregaZero ? 'd-none' : 'd-none d-sm-block d-md-none mr-auto']" v-if="resources.authenticatedCustomer && resources.isEntregaZero">
            <order-summary-entrega-zero
                :resources="resources"
                :icon="entregazeroicon" />
        </div>

        <span class="ct-cart--summary-label pwc-font--primary-bold">
            {{ currentStep != 4 ? resources.summarySubtotalLabel : resources.summaryTotalsLabel }}
        </span>

        <span v-if="this.getOrderReviewPageBoolean()" class="ct-cart--summary-value ct-cart--subtotal-value pwc-font--primary-bold sub-total grand-total grand-total-sum js-checkout-grandtotal">
            {{ resources.totals.grandTotalExcludeNonFinancial }}
        </span>

        <span v-else class="ct-cart--summary-value ct-cart--subtotal-value pwc-font--primary-bold sub-total grand-total grand-total-sum js-checkout-grandtotal">
            {{ resources.totals.grandTotal }}
        </span>
    </div>`,
    computed: {
        ...mapGetters(["getOrderReviewPageBoolean"])
    },
    props: ["resources", "entregazeroicon", "currentStep"]
});

/**
 * Component displaying the order subtotal excluding non-financial amounts and retention fees.
 * Show the value of the order total before any additional retention charges are applied.
 */
const OrderSummaryTotalWithoutRetention = Vue.component("order-summary-total-without-retention", {
    template:/*html*/ `
    <div class="ct-cart--summary-info-block ct-cart--subtotal-review mt-4 mb-1">
        <span class="ct-cart--summary-label ct-cart--subtotal-review d-flex align-items-center">
            {{ resources.summarySubtotalLabel }}
        </span>
        <span class="ct-cart--summary-value">
            {{ resources.totals.grandTotalExcludeNonFinancialAndRetention }}
        </span>
    </div>`,
    props: ["resources"]
});

/**
 * Component displaying the order retention value
 * Show the retention value and provides a tooltip with more details when hovered over the question mark icon.
 */
const OrderSummaryRetention = Vue.component("order-summary-retention", {
    template:/*html*/ `
    <div class="ct-cart--summary-info-block mt-2 mb-3 mb-md-4">
        <span class="ct-cart--summary-label pwc-font--primary-regular d-flex align-items-center mb-0">
            {{ resources.summaryRetentionLabel }}
            <span v-html="questionmarkicon"
                class="button--transparent-secondary ct-cart--summary-retention-info pwc-tooltip-trigger d-flex"
                data-toggle="tooltip"
                data-placement="left"
                :title="resources.summaryRetentionTooltip">
            </span>
        </span>
        <span class="ct-cart--summary-value pwc-font--primary-regular mb-0">
            {{ resources.totals.retentionValue }}
        </span>
    </div>`,
    methods: {
        initializeTooltip() {
            this.$nextTick(() => {
                const tooltipElement = this.$el.querySelector(".ct-cart--summary-retention-info");
                if (tooltipElement) {
                    $(tooltipElement).tooltip({ placement: "top" });
                }
            });
        }
    },
    mounted() {
        this.initializeTooltip();
    },
    props: ["resources", "questionmarkicon"]
});

/**
 * Order summary Poupa Component
 */
const OrderSummaryPoupa = Vue.component("order-summary-poupa", {
    template:/*html*/ `
    <div :class="['js-poupa-area ct-cart--discount-area-block', resources.totalProductDiscount && resources.totalProductDiscount != 'N/A' ? '' : 'd-none', resources.totalAcumulatedDiscount && resources.totalAcumulatedDiscount != 'N/A' && formattedAcumula != '0,00' ? 'mr-sm-1 mr-md-0' : '']">
        <div class="d-flex align-items-center justify-content-center w-100">
            <img class="img-fluid ct-cart--discount-img"
                :src="resources.poupaImage"
                :alt="resources.summaryPoupaLabel" />
            <span class="total-discount-label">
                {{ resources.summaryPoupaLabel }}
            </span>
            <span class="total-discount-value pwc-font--primary-bold js-poupa-discount" v-if="resources.totalProductDiscount && resources.totalProductDiscount != 'N/A'">
                {{ resources.totalProductDiscount }}
            </span>
        </div>
    </div>`
    ,
    computed: {
        formattedAcumula() {
            return this.resources && removeCurrencyFromStringAndConverToNumber(this.resources.totalAcumulatedDiscount);
        }
    },
    props: ["resources"]
});

/**
 * Order summary Acumula Component
 */
const OrderSummaryAcumula = Vue.component("order-summary-acumula", {
    template:/*html*/ `
    <div v-if="resources" :class="['js-acumula-area ct-cart--discount-area-block', resources.totalAcumulatedDiscount && resources.totalAcumulatedDiscount != 'N/A' && formattedAcumula != '0,00' ? '' : 'd-none', resources.totalProductDiscount && resources.totalProductDiscount != 'N/A' ? 'ml-sm-1 ml-md-0' : '']">
        <div class="d-flex align-items-center justify-content-center w-100">
            <img class="img-fluid ct-cart--discount-img"
                :src="resources.acumulaImage"
                :alt="resources.summaryAcumulaLabel" />
            <span class="total-discount-label">
                {{ resources.summaryAcumulaLabel }}
            </span>
            <span class="total-discount-value pwc-font--primary-bold js-acumula-discount">
                €{{ resources.totalAcumulatedDiscount }}
            </span>
        </div>
    </div>`
    ,
    computed: {
        formattedAcumula() {
            return this.resources && removeCurrencyFromStringAndConverToNumber(this.resources.totalAcumulatedDiscount);
        }
    },
    props: ["resources"]
});

/**
 * Order summary Continue button Component
 */
const OrderSummaryContinueButton = Vue.component("order-summary-continue-button", {
    template:/*html*/ `
        <div class="checkout-continue">
            <button 
                :class="['button button--primary d-inline-flex justify-content-center align-items-center w-100', currentStep == 2 ? 'submit-shipping' : 'submit-payment']" 
                type="submit" 
                name="submit"
                :data-checkout-payment-url="currentStep == 2 ? resources.summaryCheckoutPaymentURL : null"
                :data-summary-continue-btn-label="currentStep == 2 ? resources.summaryContinueBtnLabel : null"
                :data-summary-steps-text-tracker="currentStep == 2 ? resources.summaryStepsTextTracker : null"
                :value="currentStep == 2 ? 'submit-shipping' : 'submit-payment'" 
                @click="checkoutContinueBtnChecks">
                <span class="checkout-continue--msg">{{ summaryContinueBtnLabel }}</span>
            </button>
        </div>`
    ,
    computed: {
        summaryContinueBtnLabel() {
            return this.currentStep == 2
                ? this.resources.shipping.length > 1
                    ? this.resources.summaryStepsTextTracker?.replace("{0}", 2) + this.resources.shipping.length
                    : this.resources.summaryContinueBtnLabel
                : this.resources.summaryContinueToSummary;
        }
    },
    methods: {
        checkoutContinueBtnChecks() {
            switch (this.currentStep) {
                case 3: {
                    const { taxNumberValid, companyNameValid } = checkCompanyRequiredFields();

                    if (!taxNumberValid || !companyNameValid) {
                        scrollToCompanyRequiredFields(!taxNumberValid, !companyNameValid);
                        return;
                    }

                    scrollToPaymentMethods();

                    break;
                }
            }
        }
    },
    props: ["resources", "currentStep"]
});

/**
 * Order summary Place order button Component
 */
const OrderSummaryPlaceOrderButton = Vue.component("order-summary-place-order-button", {
    template:/*html*/ `
    <div class="ct-cart--checkout-button">
        <div class="review-continue">
            <button class="button button--primary d-inline-flex justify-content-center w-100 place-order js-place-order"
                type="submit"
                name="place-order-btn"
                value="place-order"
                :data-number-invalid-coupons="numberOfInvalidCoupons"
                :data-action="resources.summaryPlaceOrderAction"
                :data-order-validate="resources.summaryOrderValidateURL"
                :data-checkout-url="resources.summaryCheckoutBeginURL"
                :data-cart-page-url="resources.summaryCartShowURL"
            >
                <span>{{ resources.summaryPlaceOrderBtnLabel }}</span>
            </button>
        </div>
    </div>`,
    props: ["resources"],
    computed: {
        numberOfInvalidCoupons() {
            return this.resources.totals &&
                this.resources.totals.discounts &&
                this.resources.totals.discounts.filter(discount => discount.type === "coupon" && !discount.applied).length;
        }
    }
});

export {
    OrderSummaryTotal,
    OrderSummaryPoupa,
    OrderSummaryAcumula,
    OrderSummaryContinueButton,
    OrderSummaryPlaceOrderButton,
    OrderSummaryRetention,
    OrderSummaryTotalWithoutRetention
};
